import { Typography } from 'antd'
import { TextProps } from 'antd/es/typography/Text'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import remarkGfm from 'remark-gfm'
import { styled } from 'styled-components'

const MarkdownTextWrapper = styled(Typography.Text)`
  // white-space: pre-line;

  p:last-child {
    margin-bottom: 0;
  }

  table {
    border-collapse: collapse;
    width: 100%;
    margin: 20px 0;
  }

  th,
  td {
    border: 1px solid #ddd;
    text-align: left;
    padding: 8px;
  }

  th {
    background-color: #f2f2f2;
  }
`

type Props = TextProps & {
  content: string
}

export const RenderMarkdownContent: React.FC<Props> = ({
  content = '',
  ...props
}) => {
  const { type, italic = false } = props

  // ensure single line breaks (\n) render properly
  const contentFormatted = content.replace(/(?<!\n)\n(?!\n)/g, '  \n')

  return (
    <MarkdownTextWrapper type={type} italic={italic}>
      <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]}>
        {contentFormatted}
      </ReactMarkdown>
    </MarkdownTextWrapper>
  )
}
